export interface Restaurant {
  id: number;
  name: string;
  address: string;
  phone: string;
  description: string;
  priceRange: string;
  rating: number;
}

export const turkishRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Seraser Fine Dining",
    address: "Selçuk, Paşa Cami Sk. No:14, 07100",
    phone: "+90 242 247 6015",
    description: "Elegant Ottoman cuisine in a historic mansion with garden seating",
    priceRange: "₺₺₺₺",
    rating: 4.3
  },
  {
    id: 2,
    name: "7 Mehmet Restaurant",
    address: "Meltem, Dumlupınar Bulvarı No:201",
    phone: "+90 444 0707",
    description: "Traditional Turkish dishes with stunning Mediterranean views",
    priceRange: "₺₺₺",
    rating: 4.2
  },
  {
    id: 3,
    name: "Vanilla Lounge",
    address: "Barbaros, Hesapçı Sk. No:33, 07100 Muratpaşa/Antalya",
    phone: "+90 242 247 6013",
    description: "Modern Turkish cuisine in a charming old town setting and a fireplace",
    priceRange: "₺₺₺",
    rating: 4.4
  },
  {
    id: 4,
    name: "Parlak Restaurant",
    address: "Elmalı, 1. Sk. Zincirli Han İçi, 07040",
    phone: "+90 242 241 6553",
    description: "Traditional Turkish cuisine in a cozy informal setting",
    priceRange: "₺₺",
    rating: 4.5
  },
  {
    id: 5,
    name: "Sıralı Kebap",
    address: "Lara Caddesi No:419,Çağlayan Mahallesi, 07230 Muratpaşa/Antalya",
    phone: "+90 242 244 8010",
    description: "Modest eatery with great lamb dishes and innovative takes on traditional Turkish cuisine",
    priceRange: "₺₺₺₺",
    rating: 4.3
  },
  {
    id: 6,
    name: "Hacı Saad Kebap",
    address: "Kaleiçi, Zeytin Çıkmazı Sok. No:4",
    phone: "+90 242 324 0707",
    description: "Traditional Turkish dishes, has a happy hour",
    priceRange: "₺₺₺",
    rating: 4.0
  }
];

export const burgerRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Mahalle Burger Eski Lara",
    address: "Muratpaşa/Antalya",
    phone: "+90 850 242 0742",
    description: "Premium burgers with fresh buns in modern setting",
    priceRange: "₺₺₺",
    rating: 4.4
  },
  {
    id: 2,
    name: "Tezgah Burger Lara",
    address: "Şirinyalı, Ersoy Sitesi No:177/A, 07160",
    phone: "+90 505 829 7859",
    description: "Gourmet burgers with creative toppings and craft beers",
    priceRange: "₺₺₺",
    rating: 4.7
  },
  {
    id: 3,
    name: "Buffalo Burger",
    address: "Güzeloba, Rauf Denktaş Cd No:20, 07230",
    phone: "+90 242 349 0053",
    description: "Best salads in town also they have hotdogs",
    priceRange: "₺₺",
    rating: 4.4
  },
  {
    id: 4,
    name: "Manjoo Burger",
    address: "Lara, Fener Cad. No:12",
    phone: "+90 242 323 5678",
    description: "Gourmet burgers with creative toppings and craft beers",
    priceRange: "₺₺₺",
    rating: 4.6
  },
  {
    id: 5,
    name: "XL Burger Güzeloba",
    address: "Abdullah akdoğar sitesi, Rauf Denktaş Cd 07230",
    phone: "+90 242 324 8888",
    description: "American-style burgers, creative sauces, and fries",
    priceRange: "₺₺",
    rating: 4.7
  },
  {
    id: 6,
    name: "Smokey BBQ & Burger",
    address: "Arapsuyu, 609. Sk. no12a, 07230 Konyaaltı/Antalya",
    phone: "+90 543 440 1207",
    description: "Premium meat burgers great for watching sports",
    priceRange: "₺₺₺",
    rating: 4.7
  }
];

export const sushiRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Japonaki",
    address: "Barbaros, Kocatepe Sk. No:17, Muratpaşa",
    phone: "+90 549 541 9500",
    description: "Chef makes the sushi in front of you",
    priceRange: "₺₺₺₺",
    rating: 4.7
  },
  {
    id: 2,
    name: "Asmani",
    address: "10, Akra Hotel, Lara Cd. No:24",
    phone: "+90 242 316 2021",
    description: "On top of Hotel Akra amazing patio",
    priceRange: "₺₺₺₺",
    rating: 4.2
  },
  {
    id: 3,
    name: "Kodo Sushi",
    address: "Arapsuyu, 7. Cd. No:5, 07070 Konyaaltı",
    phone: "+90 538 738 8166",
    description: "Premium-casual Japanese restaurant",
    priceRange: "₺₺₺₺",
    rating: 4.7
  },
  {
    id: 4,
    name: "Sushi Co",
    address: "Çağlayan, 2052. Sk. No:16, Muratpaşa",
    phone: "+90 444 7 874",
    description: "Traditional Japanese cuisine",
    priceRange: "₺₺₺",
    rating: 4.6
  },
  {
    id: 5,
    name: "SUGOi Sushi Express",
    address: "Gürsu, 320. Sk. No:27A, Konyaaltı",
    phone: "+90 543 126 0707",
    description: "Open Kitchen concept fresh ingredients",
    priceRange: "₺₺₺",
    rating: 4.6
  },
  {
    id: 6,
    name: "Yotto Sushi",
    address: "Güzeloba, Havaalanı Cd. No: 67 D:15A",
    phone: "+90 850 450 1555",
    description: "Special set offers and Wok",
    priceRange: "₺₺₺",
    rating: 4.2
  }
];

export const mexicanRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Escobar Mexican Rest",
    address: "Fener, Fener Cd. No:9/4, Muratpaşa",
    phone: "+90 541 645 7646",
    description: "Spicy Mexican tacos and burritos in a lively setting",
    priceRange: "₺₺₺",
    rating: 4.1
  },
  {
    id: 2,
    name: "Grace Lounge",
    address: "Kılıçarslan Mah, Sakarya Sk",
    phone: "+90 533 150 3019",
    description: "Hidden Oasis in old town Antalya",
    priceRange: "₺₺",
    rating: 4.4
  },
  {
    id: 3,
    name: "Pio Gastro Bar",
    address: "Lara, Fener Cad. No:34",
    phone: "+90 242 247 6015",
    description: "Street dishes of Latin America and great cocktails",
    priceRange: "₺₺₺",
    rating: 4.2
  },
  {
    id: 4,
    name: "Ava Antalya",
    address: "Land of legends",
    phone: "+90 507 634 0834",
    description: "Hidden gem exotic Latin American Rest",
    priceRange: "₺₺₺",
    rating: 4.7
  },
  {
    id: 5,
    name: "Azuu PUB & Bistro",
    address: "Çağlayan, 2048. Sk. No:18, Muratpaşa",
    phone: "+90 242 323 5757",
    description: "Mix of  Mexican and Italian flavours with nice decor",
    priceRange: "₺₺",
    rating: 4.8
  },
  {
    id: 6,
    name: "XL Taco'S Döner",
    address: "Deniz mahallesi, Muratpaşa",
    phone: "+90 242 502 0000",
    description: "Mexican favourites with a Turkish-style twist",
    priceRange: "₺₺",
    rating: 4.3
  }
];

export const pizzaRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Piccolo Neapolitan Pizza",
    address: "Şirinyalı, Lara Cd. No:177 B, Muratpaşa",
    phone: "+90 535 449 2024",
    description: "Authentic Neapolitan pizza with open kitchen and vegan options",
    priceRange: "₺₺",
    rating: 4.8
  },
  {
    id: 2,
    name: "il Vicino Pizzeria",
    address: "Tuzcular, Paşa Cami Sk. No:8, Muratpaşa",
    phone: "+90 242 244 4053",
    description: "Contemporary Italian pizzeria serving wood-fired pizza",
    priceRange: "₺₺₺",
    rating: 4.1
  },
  {
    id: 3,
    name: "Pizza Argentina",
    address: "Gürsu, 306. Sk. No:5/1, Konyaaltı",
    phone: "+90 242 228 4992",
    description: "You can mix and match your slices here :)",
    priceRange: "₺₺",
    rating: 4.4
  },
  {
    id: 4,
    name: "Da Vinci Pizza",
    address: "Fosforlu Beach karşısı",
    phone: "+90 551 025 8711",
    description: "Perfect for thin crust lovers",
    priceRange: "₺₺",
    rating: 4.1
  },
  {
    id: 5,
    name: "Bella Vita Bistro",
    address: "Çağlayan, Lara Cd. 315/1, Muratpaşa",
    phone: "+90 0544 784 7912",
    description: "Traditional Italian pizzeria by the sea",
    priceRange: "₺₺",
    rating: 4.6
  },
  {
    id: 6,
    name: "Shakespeare Bistro",
    address: "Fener, Fener Cd. No: 1,  Muratpaşa",
    phone: "+90 549 716 3157",
    description: "Family-friendly restaurant with diverse menu and a great fungi pizza",
    priceRange: "₺₺₺",
    rating: 4.6
  }
];

export const fishRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Antalya Balikevi",
    address: "Muratpaşa, Çağlayan",
    phone: "+90 530 741 6607",
    description: "Classic seafood dishes with and outdoor garden",
    priceRange: "₺₺₺₺",
    rating: 4.4
  },
  {
    id: 2,
    name: "Lara Balik",
    address: "Tevfik Işık Cd. No:8",
    phone: "+90 242 313 1399",
    description: "Beachfront seafood dining with Amazing views",
    priceRange: "₺₺₺₺",
    rating: 4.2
  },
  {
    id: 3,
    name: "Fener Balik",
    address: "Fener, 07160 Muratpaşa/Antalya",
    phone: "+90 533 148 2880",
    description: "located under an old lighthouse",
    priceRange: "₺₺",
    rating: 4.0
  },
  {
    id: 4,
    name: "Balıkçı İrfan",
    address: "Şirinyalı, 1504. Sk. No:1, 07160",
    phone: "+90 533 365 7723",
    description: "Vintage Fish house with an Experienced Chef",
    priceRange: "₺₺₺₺",
    rating: 4.2
  },
  {
    id: 5,
    name: "Çıtır Balık",
    address: "Kılınçarslan, Atatürk Cd. No:79, 07100",
    phone: "+90 242 243 9333",
    description: "Crispy street food fish sandwiches to die for",
    priceRange: "₺₺",
    rating: 4.5
  },
  {
    id: 6,
    name: "61 Hamsi Tava",
    address: "Meydankavağı, İsmail Cem Cd No:56, 07200",
    phone: "+90 242 237 6161",
    description: "Famous for its anchovy dish and friendly atmosphere",
    priceRange: "₺₺",
    rating: 4.4
  }
];

export const steakRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "B12 Steak & Kasap",
    address: "Çağlayan, Fener Cd. Muratpaşa",
    phone: "+90 242 323 3310",
    description: "Elegant steakhouse diverse barbeque dishes",
    priceRange: "₺₺₺",
    rating: 4.5
  },
  {
    id: 2,
    name: "The Grill house",
    address: "Kuşkavağı, Akdeniz Blv. Konyaaltı",
    phone: "+90 242 229 8686",
    description: "Premium meat experience paired with fine wine",
    priceRange: "₺₺₺₺",
    rating: 4.4
  },
  {
    id: 3,
    name: "Vahap Usta",
    address: "Gürsu, Atatürk Blv. Konyaaltı",
    phone: "+90 242 238 9900",
    description: "Beloved steakhouse with tender meats",
    priceRange: "₺₺₺₺",
    rating: 4.4
  },
  {
    id: 4,
    name: "Ala Aksam",
    address: "Land of Legends",
    phone: "+90 501 743 0704",
    description: "Elegant dining experience in the beautiful Land of Legends",
    priceRange: "₺₺₺₺",
    rating: 4.6
  },
  {
    id: 5,
    name: "Kaleiçi Steak Gastro Bar",
    address: "Kaleiçi",
    phone: "+90 544 668 0700",
    description: "A steak restaurant and gastro bar built on a 2000-year-old historical museum",
    priceRange: "₺₺₺₺",
    rating: 4.6
  },
  {
    id: 6,
    name: "Ship inn Marina Rest.",
    address: "Liman Mahallesi, 07130 Konyaaltı",
    phone: "+90 532 389 1299",
    description: "Authentic dishes right by the deep blue Mediterranean Sea",
    priceRange: "₺₺₺",
    rating: 4.5
  }
];

export const koreanRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Sopung Kore Lara ",
    address: "Yeşilbahçe.Muratpaşa",
    phone: "+90 531 923 7522",
    description: "Authentic Korean cuisine and complex flavours",
    priceRange: "₺₺",
    rating: 4.5
  },
  {
    id: 2,
    name: "Sopung Kore Konyaaltı ",
    address: "Altınkum, Belediye Cd. Konyaaltı.",
    phone: "+90 549 128 8207",
    description: "Modern Korean restaurant with bibimbap, bulgogi, and kimchi specialties",
    priceRange: "₺₺",
    rating: 4.5
  },
  {
    id: 4,
    name: "Kore Pocha",
    address: "Gürsu, Konyaaltı",
    phone: "+90 530 339 5677",
    description: "Authentic Korean cuisine big portions",
    priceRange: "₺₺₺",
    rating: 4.8
  },
  {
    id: 5,
    name: "Cafe BUBU Lara",
    address: "Kolaylar Apt, Fener, Muratpaşa",
    phone: "+90 554 007 2084",
    description: "Hidden gem offering Korean home-style dishes",
    priceRange: "₺₺₺",
    rating: 4.6
  },
  {
    id: 6,
    name: "Korelee",
    address: "Arapsuyu, 605. Sk. No:2, Konyaaltı",
    phone: "+90 551 543 0708",
    description: "Elegant Korean restaurant with traditional decor and authentic flavors",
    priceRange: "₺₺₺",
    rating: 4.1
  }
];

export const italianRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Ristorante Italiano",
    address: "Kaleiçi, Mermerli Sok. No:22",
    phone: "+90 242 247 9900",
    description: "Authentic Italian cuisine with homemade pasta and traditional recipes",
    priceRange: "₺₺₺₺",
    rating: 4.8
  },
  {
    id: 2,
    name: "La Dolce Vita",
    address: "Marina, Kaleiçi",
    phone: "+90 242 241 8800",
    description: "Elegant Italian dining with harbor views and extensive wine selection",
    priceRange: "₺₺₺₺",
    rating: 4.7
  },
  {
    id: 3,
    name: "Trattoria Toscana",
    address: "Konyaaltı Beach Park",
    phone: "+90 242 238 6600",
    description: "Tuscan-style restaurant with fresh seafood pasta and beachfront seating",
    priceRange: "₺₺₺",
    rating: 4.6
  },
  {
    id: 4,
    name: "Osteria del Mare",
    address: "Lara, Güzeloba Mahallesi",
    phone: "+90 242 323 7700",
    description: "Italian seafood specialties with Mediterranean flavors",
    priceRange: "₺₺₺₺",
    rating: 4.7
  },
  {
    id: 5,
    name: "Pasta e Basta",
    address: "MarkAntalya AVM, Lara",
    phone: "+90 242 324 5500",
    description: "Casual Italian eatery with fresh pasta made daily and wood-fired pizzas",
    priceRange: "₺₺",
    rating: 4.4
  },
  {
    id: 6,
    name: "Villa Romana",
    address: "Kaleiçi, Hesapçı Sok. No:48",
    phone: "+90 242 247 6600",
    description: "Romantic Italian restaurant in historic mansion with garden terrace",
    priceRange: "₺₺₺₺",
    rating: 4.8
  }
];

export const chineseRestaurants = [
  {
    id: 1,
    name: "Dragon Palace",
    description: "Authentic Cantonese and Szechuan cuisine in an elegant setting. Famous for dim sum, Peking duck, and hand-pulled noodles. Traditional recipes passed down through generations.",
    address: "Lara Beach, Güzeloba Mahallesi, Antalya",
    phone: "+90 242 324 5678",
    rating: "4.7",
    priceRange: "₺₺₺"
  },
  {
    id: 2,
    name: "Golden Wok",
    description: "Contemporary Chinese dining with a focus on fresh ingredients and bold flavors. Specializing in stir-fries, hot pots, and authentic dumplings made fresh daily.",
    address: "Konyaaltı, Arapsuyu Mahallesi, Antalya",
    phone: "+90 242 228 3456",
    rating: "4.6",
    priceRange: "₺₺"
  },
  {
    id: 3,
    name: "Shanghai Garden",
    description: "Experience the flavors of Shanghai with our specialty xiaolongbao (soup dumplings), sweet and sour dishes, and traditional tea service in a beautiful garden atmosphere.",
    address: "Kaleiçi, Old Town, Antalya",
    phone: "+90 242 241 7890",
    rating: "4.8",
    priceRange: "₺₺₺"
  },
  {
    id: 4,
    name: "Bamboo House",
    description: "Family-friendly Chinese restaurant offering a wide variety of dishes from different regions. Known for generous portions, friendly service, and authentic flavors.",
    address: "Muratpaşa, Meltem Mahallesi, Antalya",
    phone: "+90 242 316 2345",
    rating: "4.5",
    priceRange: "₺₺"
  },
  {
    id: 5,
    name: "Mandarin Kitchen",
    description: "Upscale Chinese dining featuring signature dishes like Kung Pao chicken, Mapo tofu, and crispy spring rolls. Extensive menu with vegetarian options available.",
    address: "Kepez, Varsak Mahallesi, Antalya",
    phone: "+90 242 342 9012",
    rating: "4.7",
    priceRange: "₺₺₺"
  },
  {
    id: 6,
    name: "Oriental Express",
    description: "Fast-casual Chinese eatery perfect for quick, delicious meals. Popular for takeout and delivery. Specialties include fried rice, chow mein, and sweet and sour pork.",
    address: "Lara, Fener Mahallesi, Antalya",
    phone: "+90 242 323 4567",
    rating: "4.4",
    priceRange: "₺"
  }
];

export const persianRestaurants: Restaurant[] = [
  {
    id: 1,
    name: "Shiraz Persian Cuisine",
    address: "Kaleiçi, Hesapçı Sok. No:42, 07100 Muratpaşa/Antalya",
    phone: "+90 242 247 8900",
    description: "Authentic Persian kebabs, stews, and rice dishes in elegant Old Town setting",
    priceRange: "₺₺₺₺",
    rating: 4.7
  },
  {
    id: 2,
    name: "Tehran House",
    address: "Lara, Güzeloba Mahallesi, 07230 Muratpaşa/Antalya",
    phone: "+90 242 323 5600",
    description: "Traditional Persian hospitality with aromatic basmati rice and saffron specialties",
    priceRange: "₺₺₺₺",
    rating: 4.6
  },
  {
    id: 3,
    name: "Persepolis Restaurant",
    address: "Konyaaltı, Arapsuyu Mah. 07070 Konyaaltı/Antalya",
    phone: "+90 242 238 7200",
    description: "Family-run Persian eatery featuring homemade fesenjan and ghormeh sabzi",
    priceRange: "₺₺₺₺",
    rating: 4.8
  },
  {
    id: 4,
    name: "Saffron Palace",
    address: "Muratpaşa, Meltem Mah. 07100 Muratpaşa/Antalya",
    phone: "+90 242 316 4500",
    description: "Upscale Persian dining with live traditional music and premium meats",
    priceRange: "₺₺₺₺",
    rating: 4.5
  },
  {
    id: 5,
    name: "Babylon Persian Kitchen",
    address: "Lara, Fener Cad. No:88, 07160 Muratpaşa/Antalya",
    phone: "+90 242 323 9100",
    description: "Contemporary Persian fusion with classic flavors and modern presentation",
    priceRange: "₺₺₺₺",
    rating: 4.6
  },
  {
    id: 6,
    name: "Kashan Grill",
    address: "Kepez, Varsak Mah. 07320 Kepez/Antalya",
    phone: "+90 242 342 7800",
    description: "Casual Persian grill house specializing in joojeh and koobideh kebabs",
    priceRange: "₺₺₺₺",
    rating: 4.4
  }
];
